<template>
  <q-page class="q-pa-sm page-background">
    <div class="row frosted">
      <div class="col-10 wrap q-pa-md">
        <div class="text-h6">Useri inregistrati</div>
        <q-separator></q-separator>
        <q-list bordered>
          <q-scroll-area class="q-mt-md" style="height:48.5rem;">
            <q-item v-for="(user,index) in users" :key="user">
              <q-item-section avatar>
                <q-avatar rounded>
                  <img :src="user.profilepic">
                </q-avatar>
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-body1">
                  {{user.displayName}}
                </q-item-label>
                <q-item-label caption>
                  {{user.email}}
                </q-item-label>
              </q-item-section>
              <q-item-section>
                <div class="row text-center items-center justify-center">
                  <span class="text-body1">Admin:</span> <span v-if="user.admin">
                    <q-icon color="green" size="sm" name="mdi-check"></q-icon>
                  </span> <span v-else>
                    <q-icon color="red" size="sm" name="mdi-cancel"></q-icon>
                  </span>
                </div>

              </q-item-section>
              <q-item-section>
                <q-item-label>
                  <div class="row items-center justify-center">
                    <q-btn push color="blue-10" @click="openOptions(user,index)" label="Optiuni" icon="mdi-cogs">

                    </q-btn>
                  </div>
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-scroll-area>
        </q-list>
      </div>
      <div class="col-2 q-pa-md">
        <div class="text-h6">Statistici</div>
        <q-separator></q-separator>
        <div class="row q-pt-sm">
          <div class="q-pt-md">
            <div class="text-body1">Utilizatori inregistrati: <span class="text-bold">{{statistics.totalUsers}}</span></div>
            <div class="text-body1">Administratori: <span class="text-bold">{{statistics.admins}}</span> </div>
          </div>
        </div>
      </div>
      <!-- <latest-post />
      <news class="col-10 col-md-7" :title="news_title" :content="news_content" :admin="isAdmin" /> -->
    </div>

    <q-dialog v-model="showOptions">
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Editeaza datele lui {{chosenUser.displayName}}</div>
        </q-card-section>
        <q-card-section class="q-pt-none">
          <div class="text-body1">Nume</div>
          <q-input class="q-mt-sm" v-model="chosenUser.displayName" filled dense />
          <div class="text-body1 q-mt-md">Mail</div>
          <q-input class="q-mt-sm" v-model="chosenUser.email" filled dense />
          <div class="text-body1 q-mt-md">Privilegii administrator</div>
          <q-toggle v-model="chosenUser.admin" checked-icon="check" color="green" unchecked-icon="clear" />
        </q-card-section>
        <q-card-actions align="right">
          <q-btn label="Anuleaza" flat color="red" v-close-popup />
          <q-btn label="Salveaza" color="blue-8" @click="ApplyEdit()" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<style>
.page-background {
  background-image: url("../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.frosted {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
</style>

<script>
import { ref } from "vue";
// import RandomFacts from "../components/RandomFacts.vue";
// import Statistics from "../components/Statistics.vue";
// import News from "../components/Announcements.vue";
// import QuickAccess from "../components/QuickAccess.vue";
// import LatestPost from "../components/LatestPost.vue";
import firebase from "firebase";
import { store } from "../store/store";

export default {
  // components: {
  //   RandomFacts,
  //   Statistics,
  //   News,
  //   QuickAccess,
  //   LatestPost,
  // },
  setup() {
    return {
      slide: ref("post1"),
      factz: ["Fact1", "Fact2", "Fact3", "Fact4", "Fact5"],
    };
  },
  data() {
    return {
      isAdmin: false,
      news_title: '',
      news_content: '',
      users: [],
      chosenUser: {},
      showOptions: false,
      statistics: {
        totalUsers:0,
        admins:0,
      }
    }
  },
  methods: {
    Statistics() {
      setTimeout(()=>{
        this.statistics.totalUsers = Object.keys(this.users).length
        let totalAdmins = 0
        for (const id in this.users) {
          if (Object.hasOwnProperty.call(this.users, id)) {
            const user = this.users[id];
            if (user.admin){
              totalAdmins++
            }
          }
        }
        this.statistics.admins = totalAdmins
        // console.log(totalAdmins)
      },1000)
    },
    openOptions(user, index) {
      this.chosenUser = user
      this.chosenUser.index = index
      this.showOptions = true
      // console.log(this.chosenUser)
    },
    GetRegisteredUsers() {
      firebase.database().ref("users").on("value", (snapshot) => {
        const data = snapshot.val()
        this.users = data
        this.Statistics()
      })
    },
    ApplyEdit() {
      firebase.database().ref(`users/${this.chosenUser.index}`).update({
        admin: this.chosenUser.admin,
        displayName: this.chosenUser.displayName,
        email: this.chosenUser.email,
      })
    },
    AdminState() {
      const user_id = firebase.auth().currentUser.uid
      firebase.database().ref("users/" + user_id).once("value").then((snapshot) => {
        const data = snapshot.val()
        this.isAdmin = data.admin
      })
    },
    GetNewsData() {
      firebase.database().ref("news").on("value", (snapshot) => {
        const data = snapshot.val()
        if (data) {
          let anunturi = []
          for (let anunt in data) {
            anunturi.push(data[anunt])
          }
          anunturi = anunturi.sort((a, b) => new Date(b.date) - new Date(a.date))
          const latest_data = anunturi[0]
          this.news_title = latest_data.title
          this.news_content = latest_data.content
          store.commit({
            type: "UPDATE_NEWS",
            title: latest_data.title,
            content: latest_data.content
          })
        }
      })
    },

  },
  created() {
    setTimeout(() => {
      this.GetRegisteredUsers()
      this.AdminState()
    }, 1000)
  }
};
</script>